module.exports = __webpack_public_path__ + "img/icons-02.17e33ce5.svg";